export default function () {
  const widgetName = 'seoTextWidget';
  const widgetOpts = seoTextWidgetOpts;

  function addBackground(data) {
    const imgURL = data.items[0].ImageWithPath.toString();
    $('.seo-section .overlay').css('background-image', `url('${imgURL}')`);
  }
  function createTitle(data) {
    const title = data.items[0].Title;
    let detailTitle = data.items[0].DetailLinkText;
    detailTitle = detailTitle.length > 35 ? `${detailTitle.substring(0, 35)}...` : detailTitle;
    const titleString = title + detailTitle;
    // convert titleString to lowercase

    $(`#${widgetName} .card-widget-title`).replaceWith(function () {
      return $(
        `<h1 class="card-widget-title" aria-label="${titleString.toLowerCase()}">${title} <span>${detailTitle}</span></h1>`
      );
    });
    // apend after the title a div
    $(`#${widgetName} .card-widget-title`).after(
      '<span class="separator" aria-hidden="true"></span>'
    );
    // get all the nodes from the widget
    const nodes = $(`#${widgetName} .card-content`).children();
    applyAOS(nodes, 'fade-left');
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (data, owl, hasData) {
      addBackground(data);
      createTitle(data);
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false,
  });
}
